import React, { Component } from 'react';

class OpenAnswer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			config: {
				mostBeNum: false,
				numMin: '',
				numMax: ''
			}
		};
		this.handleOnChange = this.handleOnChange.bind(this);
		this.handleOnCheck = this.handleOnCheck.bind(this);
	}
	handleOnChange(e) {
		const { name, value } = e.target;
		const nextState = {
			...this.state.config,
			[name]: value
		};
		this.props.parentStateCallback(nextState, 'config');
		this.setState({
			config: {
				...nextState
			}
		});
	}
	handleOnCheck(e) {
		const { checked: value, name } = e.target;
		const nextState = {
			...this.state.config,
			[name]: value
		};
		if (!value) {
			const reset = {
				[name]: value,
				numMin: '',
				numMax: ''
			};
			this.props.parentStateCallback(reset, 'config');
			return this.setState({
				config: {
					...reset
				}
			});
		}
		this.setState({
			config: {
				...nextState
			}
		});
		this.props.parentStateCallback(nextState, 'config');
	}
	render() {
		return (
			<div className="row alert alert-dark">
				<div>
					<div className="form-check">
						<input
							type="checkbox"
							name="mostBeNum"
							checked={this.state.config.mostBeNum}
							onChange={this.handleOnCheck}
							className="form-check-input"
							id="mostBeNum"
						/>
						<label className="form-check-label" htmlFor="mostBeNum">
							La respuesta debe ser numeral.
						</label>
					</div>
					<div className={this.state.config.mostBeNum ? 'row my-3' : 'd-none'}>
						<div className="col">
							<input
								type="number"
								name="numMin"
								id="numMin"
								placeholder="Mínimo numeral"
								value={this.state.config.numMin}
								onChange={this.handleOnChange}
								className="form-control"
							/>
						</div>
						<div className="col">
							<input
								type="number"
								name="numMax"
								id="numMax"
								placeholder="Máximo numeral"
								value={this.state.config.numMax}
								onChange={this.handleOnChange}
								className="form-control"
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default OpenAnswer;



// WEBPACK FOOTER //
// ./src/components/Survey/admin/FieldCollection/OpenAnswer.js